export default __webpack_public_path__ + "static/s2-ef59ebb75541ab1e2c9831964a306b12.webp";